import React, { createContext } from 'react';
import Cookies from 'js-cookie';
import getUserInfo from '../helpers/api/userInfo.js';
import getQueryOverride from '../helpers/queryOverride.js';

const UserContext = createContext();
export default UserContext;

const cookieName = "session";
 
/* Session is set server-side, so we can only read it here */
export const getSessionCookie = () => {
    const sessionCookie = Cookies.get(cookieName);
    if(typeof sessionCookie === "undefined") {
        return { authenticated: false, stayLocal: false };
    }
    else {
        try {
            return JSON.parse(sessionCookie);
        }
        catch (error) {
            console.error(error);
            return { authenticated: false, stayLocal: false };
        }
    }
};

/* Best available display name for a user */
export const getUserDisplayName = (userContext, { includeSurname = false } = {}) => {
    const firstName = userContext.user?.given_name ?? userContext.user?.givenname;
    const surname = userContext.user?.surname;

    let name = firstName?.trim() ?? "";
    if(includeSurname) {
        name += ` ${ surname?.trim() ?? "" }`;
    }

    return name.trim() || userContext.user?.name || userContext.user?.email?.replace(/@.*/, "") || "";
};

/* Partner/Director gating, driven by SSO's pwcGlobalGradeName. Property absent entirely -> show both (testing/fallback); present -> show only the matching one. ?grade=<value> overrides pwcGlobalGradeName for testing */
export const isPartner = (userContext) => {
    const grade = getQueryOverride("grade") ?? userContext.user?.pwcGlobalGradeName;
    if(grade === undefined) {
        return true;
    }
    return /partner/i.test(grade);
};

export const isDirector = (userContext) => {
    const grade = getQueryOverride("grade") ?? userContext.user?.pwcGlobalGradeName;
    if(grade === undefined) {
        return true;
    }
    return /director/i.test(grade);
};

/* Get user data */
export const loadUserInfo = async ({ logout }) => {
    try {
        return await getUserInfo({ logout });
    }
    catch (error) {
        console.error(`Getting user info failed, ${error}`);
    }
    return {};
};
